import { useAnalytics, useNavigation } from "@/providers";
import { CreateEntityButton } from "@/shared/components/CreateEntityButton";
import { RobotoTooltip } from "@/shared/components/RobotoTooltip";

interface CreateSessionButtonProps {
  /**
   * When set, prefills the create-session page's file selection from this dataset.
   * Omit on unscoped surfaces (e.g. the top-level `/sessions` page).
   */
  datasetId?: string;
  /**
   * `primary` in the `<SessionsList>` toolbar; `secondary` in its empty state.
   * @default "primary"
   */
  variant?: "primary" | "secondary";
}

/**
 * Entry point that opens the create-session flow. Rendered in the `actions`
 * slot of `<SessionsList>` on both the unscoped `/sessions` page and the
 * dataset-scoped Sessions tab, and again inside those lists' empty states.
 */
export function CreateSessionButton({
  datasetId,
  variant = "primary",
}: CreateSessionButtonProps) {
  const { goto } = useNavigation();
  const { trackEvent } = useAnalytics();

  return (
    <RobotoTooltip title="Create a new session">
      <span>
        <CreateEntityButton
          entity="session"
          variant={variant}
          onClick={() => {
            trackEvent("CreateSessionClicked", { datasetId });
            goto.createSession({ datasetId });
          }}
        />
      </span>
    </RobotoTooltip>
  );
}
